export default {
      id: "circle__signal-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#circle__signal",
      toString: function () {
        return this.url;
      }
    }